export const DE: Record<string, string> = {
  "Recommended for you": "Für Sie empfohlen",
  "Resource added to favorite": "Ressource zu Favoriten hinzugefügt",
  "Failed to add resource to favorite": "Fehler beim Hinzufügen der Ressource zu Favoriten",
  "Resource removed from favorite": "Ressource aus Favoriten entfernt",
  "Failed to remove resource from favorite": "Fehler beim Entfernen der Ressource aus Favoriten",
  "Calendar": "Kalender",
  "View Detail": "Details anzeigen",
  "Add to favorites": "Zu Favoriten hinzufügen",
  "Remove from favorites": "Aus Favoriten entfernen",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Beschreibung: VIP-Besprechungsraum mit toller Aussicht und bequemen Stühlen.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Zur gewählten Zeit sind an Ihrem Standort oder in Ihren Favoriten keine Ressourcen verfügbar.",
  "You have these options:": "Sie haben folgende Optionen:",
  "Change the meeting time.": "Ändern Sie die Besprechungszeit.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Verwenden Sie die Schaltfläche <1>Verfügbare Zeit finden</1>, um eine neue Zeit auszuwählen.",
  "Open the search to find other resources.": "Öffnen Sie die Suche, um andere Ressourcen zu finden.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Die Ressourcentype <1>'{{resourceType}}'</1> existiert nicht auf Ihrem Standardstandort",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Die Ressourcentype <1>'{{resourceType}}'</1> kann auf einem anderen Standort gefunden werden.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klicken Sie hier</1>, um die Ressourcentype zu Ihren Standardstandorteinstellungen hinzuzufügen.",
  
  // ResourceCard
  "New Order": "Neue Bestellung",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Beim Buchung eines Pooled Resources kann nur dieser Ressourcentyp und nur eine Ressource gebucht werden.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Sie können nicht beide eine Unterressource und ihre virtuelle Ressource gleichzeitig auswählen.",
  // Settings
  "Note:": "Hinweis:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Ein stellvertretender Organisator kann dieselben E-Mails von Resource Central wie der Organisator erhalten und Bestellungen im Namen des Organisators bearbeiten.",
  "Setting updated successfully": "Einstellung erfolgreich aktualisiert",
  "Setting updated failed": "Aktualisierung der Einstellung fehlgeschlagen",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 Platz",
  "Opening hours:": "Öffnungszeiten:",
  "Buffer time {{minutes}} mins between reservations": "Pufferzeit {{minutes}} Min. zwischen Reservierungen",
  "Initial payment {{value}} pr.minute": "Anfangszahlung {{value}} pro Minute",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Gesamt {{total}} Teilnehmer",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} von {{total}} internen Teilnehmern können teilnehmen.",
  "{{external}} external is unknown.": "{{external}} externe sind unbekannt.",
  "Find available time": "Verfügbare Zeit finden",
  "Attendees": "Teilnehmer",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Klicken Sie auf Weitere Informationen, um unsere Support-Website zu besuchen",
  "Further information": "Weitere Informationen",
  
  // LocationSetting
  "Location changed": "Standort geändert",
  "Location change failed": "Standortänderung fehlgeschlagen",
  "Please select at least one location": "Bitte wählen Sie mindestens einen Standort aus",
  "Resource types": "Ressourcentypen",
  "Location": "Standort",
  "Where": "Wo",
  
  // ModalShowAttendees
  "Total": "Gesamt",
  "Available": "Verfügbar",
  "Busy": "Beschäftigt",
  "External": "Extern",
  "Internal": "Intern",
  
  // ResourceSearch
  "Search by resource name": "Nach Ressourcenname suchen",
  "Category": "Kategorie",
  "Filter by Location": "Nach Standort filtern",
  "Filter by Category": "Nach Kategorie filtern",
  "Capacity": "Kapazität",
  "Filter by Capacity": "Nach Kapazität filtern",
  "All": "Alle",
  "Filter by availability": "Nach Verfügbarkeit filtern",
  "Sort By": "Sortieren nach",
  "Loading...": "Laden...",
  
  // SelectedResources
  "Meeting Type": "Besprechungstyp",
  "Meeting Label": "Besprechungslabel",
  
  // Alert (accessibility text)
  "Check icon": "Häkchen-Symbol",
  "Close": "Schließen",
  
  // AppConstants - searchTab
  "Resource": "Ressource",
  "Person": "Person",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Wo finden Ihre Besprechungen normalerweise statt?",
  "To improve our recommendations for you we would like you to enter your normal location": "Um unsere Empfehlungen für Sie zu verbessern, möchten wir Sie bitten, Ihren üblichen Standort anzugeben",
  "What do you use most?": "Was verwenden Sie am häufigsten?",
  "To enable quicker and better search please chose you prefered resource type": "Für eine schnellere und bessere Suche wählen Sie bitte Ihren bevorzugten Ressourcentyp",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Klicken Sie auf die Ressource, um sie auszuwählen",
  "Selected Resources": "Ausgewählte Ressourcen",
  "Setting": "Einstellung",
  "Search": "Suchen",
  "Find Colleague": "Kollegen finden",
  "Quick button setting": "Schnelltasten-Einstellung",
  "Favorite": "Favorit",
  "Most Used": "Am häufigsten verwendet",
  "Colleagues": "Kollegen",
  "Resources": "Ressourcen",
  
  // AppConstants - tooltipText
  "Back": "Zurück",
  "Floor Plan": "Grundriss",
  "Expand": "Erweitern",
  "Selected resources": "Ausgewählte Ressourcen",
  "View details": "Details anzeigen",
  "Remove from My Favorites": "Aus meinen Favoriten entfernen",
  "Add to My Favorites": "Zu meinen Favoriten hinzufügen",
  "Remove": "Entfernen",
  "Favorite - Most Used": "Favorit - Am häufigsten verwendet",
  "Conflict": "Konflikt",
  "Approved": "Genehmigt",
  "Recommendeded for you": "Empfohlen für Sie",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Nur Hauptorganisator",
  "Only assistant organizer": "Nur stellvertretender Organisator",
  "Primary AND assistant organizer": "Haupt- UND stellvertretender Organisator",
  
  // FindColleague
  "Enter colleague name": "Kollegennamen eingeben",
  "Recent work items": "Aktuelle Arbeitselemente",
  "No data available": "Keine Daten verfügbar",
  "Floorplan": "Grundriss",
  "List nearby resources": "Liste der Ressourcen in der Nähe",
  "Find resource nearby": "Ressource in der Nähe finden",
  "No Resources available": "Keine Ressourcen verfügbar",
  
  // Start page
  "Next": "Weiter",
  "Failed to update default locations": "Fehler beim Aktualisieren der Standardstandorte",
  "Resource Type": "Ressourcentyp",
  
  // QuickSetting
  "Quick buttons updated successfully": "Schnelltasten erfolgreich aktualisiert",
  "Quick buttons updated failed": "Aktualisierung der Schnelltasten fehlgeschlagen",
  "Add more": "Weitere hinzufügen",
  "Apply": "Anwenden",
  "Delete": "Löschen",
  "Name": "Name",
  "Enter name": "Namen eingeben",
  "Tooltip": "Tooltip",
  "Enter tooltip": "Tooltip eingeben",
  "Type": "Typ",
  "Select type": "Typ auswählen",
  "Locations": "Standorte",
  "Select colleagues": "Kollegen auswählen",
  "Select resources": "Ressourcen auswählen",
  
  // DefaultResourceSetting
  "Resource type changed": "Ressourcentyp geändert",
  "Resource type change failed": "Änderung des Ressourcentyps fehlgeschlagen",
  "Default Resource Type": "Standard-Ressourcentyp",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Erfolgreich angewendet",
  "Apply Failed": "Anwendung fehlgeschlagen",
  "Assistant Organizer": "Stellvertretender Organisator",
  "Enter a part of the name to search for": "Geben Sie einen Teil des Namens ein, um zu suchen",
  "Mail Flow": "E-Mail-Fluss",
  "Select Mail Flow": "E-Mail-Fluss auswählen",
  
  // TileConfigurationSetting
  "Update settings successfully": "Einstellungen erfolgreich aktualisiert",
  "Update settings failed": "Aktualisierung der Einstellungen fehlgeschlagen",
  "Timeline": "Zeitachse",
  
  // SelectCategoryForm
  "And": "Und",
  "Or": "Oder",
  
  // Other
  "Resource Calendar": "Ressourcenkalender",
  
  // SettingLabels
  "Default Location": "Standardstandort",
  "Quick button": "Schnelltaste",
  "Category icons": "Kategorie-Symbole",
  "Recommendation screen": "Empfehlungsbildschirm",
  "Capacity filter": "Kapazitätsfilter",
  "AI Assistant": "KI-Assistent",
  "Tile configuration": "Kachelkonfiguration",
  "Help": "Hilfe",
  "Default Categories": "Standardkategorien",
  
  // MeetingType
  "Your must select a Meeting label": "Sie müssen ein Besprechungsetikett auswählen",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Ausgewählte Ressource: 'AOD_Copanhagen' Konfliktende Vorkommen",
  "Alternative Resource": "Alternative Ressource",
  "OK": "OK",
  "Cancel": "Abbrechen",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Ihre ausgewählte Ressource 'AOD_Copenhagen' wurde entfernt",
  "You can't book this resource as your request exceeds the available capacity.": "Sie können diese Ressource nicht buchen, da Ihre Anfrage die verfügbare Kapazität überschreitet.",
  
  // ChangeTime
  "Time changed successfully": "Zeit erfolgreich geändert",
  "Current Time": "Aktuelle Zeit",
  "Suggested Times": "Vorgeschlagene Zeiten",
  "Change Time": "Zeit ändern",
  "people are free": "Personen sind frei",
};

